module.exports = __webpack_public_path__ + "static/media/icon-marker-seagreen.fb1bf860.svg";